import { Box, Typography } from '@mui/material';
import React from 'react';
import { toLowerCase } from '../../constants/commonFunction';
import { IRulesTypeProps } from '../../pages/RewardLoyalty/components/Reward';
import { COMMON, GREY, ORANGE, PRIMARY } from '../../constants/style';

interface ITabProps {
  tabData: string[] | IRulesTypeProps[];
  selected: string;
  color?: string;
  width?: string;
  isSubText?: boolean;
  onSelect: (select: any) => void;
  placement: 'vertical' | 'horizontal';
}

const VegaTab = ({
  tabData,
  selected,
  onSelect,
  placement,
  isSubText,
  color = '#FF7B01',
  width = 'auto',
}: ITabProps) => {
  console.log('isMobile', width);
  const getValue = (rule: string | IRulesTypeProps) => {
    if (typeof rule === 'string') {
      return rule;
    } else {
      return rule.id;
    }
  };
  return (
    <Box
      sx={{
        ...(placement === 'vertical' && {
          display: 'flex',
          width: '100%',
          overflow: 'auto',
        }),
        mb: 1,
        pb: 1,
      }}
    >
      {tabData.map((rule: any) => {
        return (
          <Box
            sx={{
              px: 2,
              pt: 2,
              pb: 1,
              cursor: 'pointer',
              display: 'flex',
              flexDirection: 'column',

              ...(placement === 'vertical' && {
                alignItems: 'center',
              }),

              ...(selected === getValue(rule) &&
                placement === 'vertical' && {
                  borderBottom: `2px solid ${color}`,
                }),
              ...(selected === getValue(rule) &&
                placement === 'horizontal' && {
                  borderRight: `3px solid ${color}`,
                }),
            }}
            onClick={() => onSelect(getValue(rule))}
          >
            <Typography
              className="font-aspekta-500"
              fontSize={13}
              sx={{
                textAlign: 'center',
                width: `${width} !important`,
                ...(selected === getValue(rule)
                  ? { color: color }
                  : { color: COMMON.gray }),
              }}
            >
              {typeof rule === 'string'
                ? toLowerCase(rule)
                : toLowerCase(rule.id)}
            </Typography>
            {isSubText && (
              <Typography
                className="font-aspekta-600"
                sx={{ fontSize: 10, color: GREY.dark }}
              >
                {rule.subTxt}
              </Typography>
            )}
          </Box>
        );
      })}
    </Box>
  );
};

export default VegaTab;
